import React, { useState, useEffect } from 'react';
/**
 * boton de accion generalmente usado en secciones de catalogos
 * @param {function} action funucion que se ejecuta al dar click en el boton
 * @param {string} name nombre del boton
 * @param {string} helpText texto de ayuda para el boton, se muestra en tamaño más pequeño
 * @param {boolean} isSelected si el boton esta seleccionado este alterna entre otro comportamiento
 * @param {string} btnClass atributo opcional, sustituye a la clase de estilo por default del botón
 * @param {string} textClass atributo opcional, sustituye a la clase de estilo por default del texto
 * @param {string} btnActionClass atributo opcional, sustituye a la clase de estilo por default del botón cuando esta seleccionado
 * @returns {JSX.Element} boton de accion
 */
const Botonsubseccion = (p) => {
    const action = p.action ?? (() => { });
    const name = p.name ?? '';
    const helpText = p.helpText ?? '';
    const isSelected = p.isSelected ?? false;
    const btnClass = p.btnClass ?? 'btn btn-sm round-m w-100 border btn-light shadow border-warning';
    const btnSelectedClass = p.btnActionClass ?? 'btn btn-sm round-m w-100 border btn-warning text-bold text-center';
    const textClass = p.textClass ?? 'text-xs ms-2 text-blue4 text-500';

    return (
        <div className='col-auto mt-1 mb-1'>
            <button className={isSelected ? btnSelectedClass : btnClass}
                onClick={() => action()}>
                {name.toUpperCase()}
                {helpText !== "" && <span className={textClass}>{helpText}</span>}
            </button>
        </div>
    )

}

export default Botonsubseccion;